import { View } from 'foundations-components/transitional/components/View';
import { isTrellisTheme, useTheme } from 'foundations-theming/utils';
import FeatureTableBadge from 'pricing-pages-ui-components/badges/FeatureTableBadge';
import { MerchCardBadge } from 'pricing-pages-ui-components/badges/MerchCardBadge';
import { jsx as _jsx } from "react/jsx-runtime";
export const RecommendedBadge = ({
  badgeName
}) => {
  const theme = useTheme();
  const isTrellis = isTrellisTheme(theme);
  if (isTrellis) {
    return /*#__PURE__*/_jsx(MerchCardBadge, {
      translationKey: `pricing-pages-ui.merchCardsV2.badges.${badgeName}`,
      badgeColor: 'specialty-tertiary-on-fill-default'
    });
  }
  return /*#__PURE__*/_jsx(View, {
    position: "absolute",
    insetBlockStart: "200",
    insetInlineEnd: "200",
    children: /*#__PURE__*/_jsx(FeatureTableBadge, {
      translationKey: badgeName
    })
  });
};